document.addEventListener('DOMContentLoaded', function() {
  var mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  var mainNav = document.getElementById('main-nav');
  
  if (mobileMenuToggle && mainNav) {
    mobileMenuToggle.addEventListener('click', function() {
      mainNav.classList.toggle('active');
      this.classList.toggle('active');
    });
  }
  
  var dropdownItems = document.querySelectorAll('.nav-item.has-dropdown');
  dropdownItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        this.classList.toggle('active');
      }
    });
  });
  
  // ═══ PRODUCT GALLERY — click thumbnail to swap main image ═══
  var galleryMainImg = document.getElementById('gallery-main-img');
  var galleryThumbs = document.querySelectorAll('.gallery-thumb');

  galleryThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var fullSrc = this.dataset.full;
      if (!fullSrc || !galleryMainImg) return;
      galleryMainImg.src = fullSrc;
      galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });
  
  var faqQuestions = document.querySelectorAll('.faq-question');
  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      var item = this.parentElement;
      var wasActive = item.classList.contains('active');
      
      document.querySelectorAll('.faq-item').forEach(function(faq) {
        faq.classList.remove('active');
      });
      
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });
  
  // ── Helper: update cart count in header ──
  function updateCartCount() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var badges = document.querySelectorAll('.cart-count');
      badges.forEach(function(b) { b.textContent = cart.item_count; });
    }).catch(function() {});
  }

  // ── VIN carried from homepage search onto the Shopify cart ──
  function normalizeSearchedVin(value) {
    var vin = String(value || '').toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
    return vin.length === 17 ? vin : '';
  }

  function readSearchedVin() {
    try {
      var stored = normalizeSearchedVin(sessionStorage.getItem('qpcm_vin'));
      if (stored) return stored;
      var raw = sessionStorage.getItem('vin_decode_data');
      if (raw) {
        var decoded = JSON.parse(raw);
        return normalizeSearchedVin(decoded && decoded.vin);
      }
    } catch (e) {}
    return '';
  }

  function rememberSearchedVin(vin) {
    vin = normalizeSearchedVin(vin);
    if (!vin) return;
    try { sessionStorage.setItem('qpcm_vin', vin); } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { VIN: vin } })
    }).catch(function() {});
  }

  function vinFromCartAttributes(cart) {
    var attrs = (cart && cart.attributes) || {};
    return normalizeSearchedVin(attrs.VIN || attrs.vin || '');
  }

  function withSearchedVin(callback) {
    var vin = readSearchedVin();
    if (vin) {
      callback(vin);
      return;
    }
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var fromCart = vinFromCartAttributes(cart);
        if (fromCart) {
          try { sessionStorage.setItem('qpcm_vin', fromCart); } catch (e) {}
        }
        callback(fromCart);
      })
      .catch(function() { callback(''); });
  }

  function addToCartBody(variantId, quantity, vin) {
    var body = { id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) || 1 };
    if (vin) body.properties = { _VIN: vin };
    return body;
  }

  if (!readSearchedVin()) {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var fromCart = vinFromCartAttributes(cart);
        if (fromCart) {
          try { sessionStorage.setItem('qpcm_vin', fromCart); } catch (e) {}
        }
      })
      .catch(function() {});
  }

  // ── Collection page: Add to Cart buttons ──
  var addToCartBtns = document.querySelectorAll('.add-to-cart');
  addToCartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var originalText = this.textContent;
      this.textContent = 'ADDING...';
      this.disabled = true;

      withSearchedVin(function(vin) {
        if (vin) rememberSearchedVin(vin);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addToCartBody(variantId, 1, vin))
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          btn.textContent = 'ADDED ✓';
          updateCartCount();
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          btn.textContent = 'ERROR';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
      });
    });
  });

  // ── Product page: add item then go to cart ──
  function bindProductCheckoutForm(form) {
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = formData.get('quantity') || 1;
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'ADDING...'; submitBtn.disabled = true; }

      withSearchedVin(function(vin) {
        if (vin) rememberSearchedVin(vin);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addToCartBody(variantId, quantity, vin))
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          window.location.href = '/cart';
        })
        .catch(function() {
          if (submitBtn) submitBtn.textContent = 'ERROR — TRY AGAIN';
          setTimeout(function() {
            if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
          }, 2500);
        });
      });
    });
  }

  bindProductCheckoutForm(document.querySelector('.add-to-cart-form'));
  bindProductCheckoutForm(document.querySelector('.mobile-sticky-cart form'));
  
  var searchInput = document.querySelector('.search-input');
  if (searchInput) {
    searchInput.addEventListener('focus', function() {
      this.parentElement.style.boxShadow = '0 0 0 2px var(--color-primary)';
    });
    
    searchInput.addEventListener('blur', function() {
      this.parentElement.style.boxShadow = 'none';
    });
  }
  
  var header = document.querySelector('.site-header');
  var lastScrollTop = 0;
  
  window.addEventListener('scroll', function() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 100) {
      header.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
    } else {
      header.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
    }
    
    lastScrollTop = scrollTop;
  });
  
  var filterCheckboxes = document.querySelectorAll('.filter-options input[type="checkbox"]');
  filterCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      console.log('Filter changed:', this.name, this.value, this.checked);
    });
  });
  
  var sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      console.log('Sort changed:', this.value);
    });
  }

  // Vehicle Finder — model-to-year mapping (matching Car Computer Exchange Dodge catalog)
  var modelYears = {
    'avenger': [1995,1996,1997,1998,1999,2000,2008,2009,2010,2011,2012,2013,2014],
    'caliber': [2007,2008,2009,2010,2011,2012],
    'caravan': [1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009],
    'challenger': [2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],
    'charger': [2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],
    'dakota': [1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010],
    'dart': [2013,2014,2015,2016],
    'durango': [1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2011,2013,2014,2015,2016,2017,2018,2019,2020],
    'grand-caravan': [1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],
    'intrepid': [1998,1999,2000,2001,2002,2003,2004],
    'journey': [2009,2010,2011,2012,2013,2014,2015,2016,2017,2018,2019,2020],
    'magnum': [2005,2006,2007,2008,2009],
    'neon': [1996,1997,1998,1999,2000,2001,2002,2003,2004,2005],
    'nitro': [2007,2008,2009,2010,2011],
    'ram-pickup': [1996,1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010],
    'ram-truck-cummins-diesel': [1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016],
    'ram-van': [1996,1997,1998,1999,2000,2001,2002,2003],
    'stratus': [1998,1999,2000,2001,2002,2003,2004,2005,2006,2007],
    'viper': [2010,2016]
  };

  var finderModel = document.getElementById('finder-model');
  var finderYear = document.getElementById('finder-year');
  var finderEngine = document.getElementById('finder-engine');
  var finderBtn = document.getElementById('finder-btn');

  // Models/years that have both gas and diesel variants
  var dieselYears = {
    'ram-pickup': [1997,1998,1999,2000,2001,2002,2003,2004,2005,2006,2007,2008,2009,2010]
  };
  // Engine options per model
  var engineOptions = {
    'ram-pickup': [
      { value: 'gas', label: 'Gas' },
      { value: 'diesel', label: 'Diesel' }
    ]
  };

  function updateEngineDropdown() {
    if (!finderEngine) return;
    var model = finderModel ? finderModel.value : '';
    var year = finderYear ? parseInt(finderYear.value) : 0;

    if (model && year && dieselYears[model] && dieselYears[model].indexOf(year) !== -1) {
      finderEngine.innerHTML = '<option value="">Gas or Diesel?</option>';
      engineOptions[model].forEach(function(eng) {
        var opt = document.createElement('option');
        opt.value = eng.value;
        opt.textContent = eng.label;
        finderEngine.appendChild(opt);
      });
      finderEngine.style.display = '';
      finderEngine.disabled = false;
    } else {
      finderEngine.style.display = 'none';
      finderEngine.disabled = true;
      finderEngine.value = '';
    }
  }

  if (finderModel && finderYear) {
    finderModel.addEventListener('change', function() {
      var model = this.value;
      finderYear.innerHTML = '<option value="">Select Year</option>';

      if (model && modelYears[model]) {
        var years = modelYears[model].slice().reverse();
        years.forEach(function(y) {
          var opt = document.createElement('option');
          opt.value = y;
          opt.textContent = y;
          finderYear.appendChild(opt);
        });
        finderYear.disabled = false;
      } else {
        finderYear.disabled = true;
      }
      updateEngineDropdown();
    });

    finderYear.addEventListener('change', updateEngineDropdown);
  }

  if (finderBtn) {
    finderBtn.addEventListener('click', function() {
      var model = finderModel ? finderModel.value : '';
      var year = finderYear ? finderYear.value : '';
      var engine = finderEngine ? finderEngine.value : '';
      if (!model) {
        if (finderModel) finderModel.focus();
        return;
      }

      // If engine dropdown is visible but no selection, prompt user
      if (finderEngine && finderEngine.style.display !== 'none' && !engine) {
        finderEngine.focus();
        return;
      }

      if (engine === 'diesel') {
        if (year) {
          window.location.href = '/collections/ram-truck-cummins-diesel?year=' + year;
        } else {
          window.location.href = '/collections/ram-truck-cummins-diesel';
        }
        return;
      }

      if (year) {
        window.location.href = '/collections/' + model + '?year=' + year;
      } else {
        window.location.href = '/collections/' + model;
      }
    });
  }

  // ── Finder Tabs ──
  // Lock the vehicle-finder width so switching tabs doesn't resize it (desktop only)
  var vehicleFinder = document.querySelector('.vehicle-finder');
  if (vehicleFinder && window.innerWidth > 768) {
    var lockWidth = vehicleFinder.offsetWidth;
    if (lockWidth > 0) vehicleFinder.style.minWidth = lockWidth + 'px';
  }

  var finderTabs = document.querySelectorAll('.finder-tab');
  finderTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.dataset.tab;
      finderTabs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
      document.getElementById('finder-panel-model').style.display = target === 'model' ? '' : 'none';
      document.getElementById('finder-panel-vin').style.display = target === 'vin' ? '' : 'none';
    });
  });

  // ── VIN Lookup ──
  var vinInput = document.getElementById('vin-input');
  var vinBtn = document.getElementById('vin-btn');
  var vinResult = document.getElementById('vin-result');

  // Map NHTSA model names → our collection slugs
  var nhtsaModelMap = {
    'avenger': 'avenger',
    'caliber': 'caliber',
    'caravan': 'caravan',
    'grand caravan': 'grand-caravan',
    'challenger': 'challenger',
    'charger': 'charger',
    'dakota': 'dakota',
    'dart': 'dart',
    'durango': 'durango',
    'intrepid': 'intrepid',
    'journey': 'journey',
    'magnum': 'magnum',
    'neon': 'neon',
    'nitro': 'nitro',
    'ram 1500': 'ram-pickup',
    'ram 2500': 'ram-pickup',
    'ram 3500': 'ram-pickup',
    'ram 1500 pickup': 'ram-pickup',
    'ram 2500 pickup': 'ram-pickup',
    'ram 3500 pickup': 'ram-pickup',
    '1500': 'ram-pickup',
    '2500': 'ram-pickup',
    '3500': 'ram-pickup',
    'ram van': 'ram-van',
    'ram wagon': 'ram-van',
    'b1500': 'ram-van',
    'b2500': 'ram-van',
    'b3500': 'ram-van',
    'stratus': 'stratus',
    'viper': 'viper',
    'srt viper': 'viper'
  };

  function resolveCollection(model, fuelType) {
    var m = (model || '').toLowerCase().trim();
    // Check for Cummins diesel Ram trucks
    if ((m.indexOf('ram') !== -1 || m === '2500' || m === '3500') && fuelType && fuelType.toLowerCase().indexOf('diesel') !== -1) {
      return 'ram-truck-cummins-diesel';
    }
    // Direct match
    if (nhtsaModelMap[m]) return nhtsaModelMap[m];
    // Partial match
    for (var key in nhtsaModelMap) {
      if (m.indexOf(key) !== -1) return nhtsaModelMap[key];
    }
    return null;
  }

  function formatEngine(displacement, cylinders) {
    if (!displacement) return '';
    var liters = parseFloat(displacement).toFixed(1);
    var cyl = cylinders ? 'V' + cylinders : '';
    if (cylinders === '4') cyl = cylinders + '-cyl';
    return liters + 'L' + (cyl ? ' ' + cyl : '');
  }

  if (vinBtn && vinInput && vinResult) {
    // Auto-uppercase VIN as user types
    vinInput.addEventListener('input', function() {
      this.value = this.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
    });

    vinBtn.addEventListener('click', function() {
      var vin = vinInput.value.trim();
      if (vin.length !== 17) {
        vinInput.focus();
        vinInput.style.borderColor = '#dc3545';
        setTimeout(function() { vinInput.style.borderColor = ''; }, 2000);
        return;
      }

      vinBtn.textContent = 'LOOKING UP...';
      vinBtn.disabled = true;

      function fetchAD(v) {
        return fetch('https://automotive-computer.com/api/vin-decode.php?vin=' + v)
          .then(function(r){return r.json();})
          .catch(function(){return null;});
      }
      Promise.all([
        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + vin + '?format=json').then(function(r){return r.json();}).catch(function(){return null;}),
        fetchAD(vin)
      ]).then(function(results) {
          var data = results[0];
          var ad = results[1] && !results[1].error ? results[1] : null;
          var r = data && data.Results && data.Results[0];
          if ((!r || !r.ModelYear || r.ModelYear === '0') && !ad) {
            vinBtn.textContent = 'LOOK UP VIN';
            vinBtn.disabled = false;
            vinInput.style.borderColor = '#dc3545';
            setTimeout(function() { vinInput.style.borderColor = ''; }, 2000);
            return;
          }
          if (!r) r = {};

          var model = (ad && ad.vehicle && ad.vehicle.model) || r.Model || '';
          var year = (ad && ad.vehicle && ad.vehicle.year) || r.ModelYear || '';
          var fuelType = r.FuelTypePrimary || '';
          var make = (ad && ad.vehicle && ad.vehicle.make) || r.Make || '';
          var isDodge = make.toLowerCase() === 'dodge' || make.toLowerCase() === 'ram';

          // Store full decoded vehicle data for display on search/no-results page
          try {
            sessionStorage.setItem('vin_decode_data', JSON.stringify({
              vin: vin,
              year: String(year),
              make: make,
              model: model,
              trim: (ad && ad.trim) || r.Trim || '',
              bodyClass: (ad && ad.body) || r.BodyClass || '',
              style: (ad && ad.style) || '',
              doors: r.Doors || '',
              driveType: (ad && ad.drive) || r.DriveType || '',
              displacementL: r.DisplacementL || '',
              displacementCC: r.DisplacementCC || '',
              engineCylinders: r.EngineCylinders || '',
              engineModel: r.EngineModel || '',
              engineSummary: (ad && ad.engine) || '',
              engineHP: r.EngineHP || '',
              engineKW: r.EngineKW || '',
              engineConfiguration: r.EngineConfiguration || '',
              fuelTypePrimary: r.FuelTypePrimary || '',
              fuelTypeSecondary: r.FuelTypeSecondary || '',
              fuelInjectionType: r.FuelInjectionType || '',
              valveTrainDesign: r.ValveTrainDesign || '',
              transmission: (ad && ad.transmission) || '',
              transmissionStyle: r.TransmissionStyle || '',
              transmissionSpeeds: r.TransmissionSpeeds || '',
              gvwr: r.GVWR || '',
              plantCity: r.PlantCity || '',
              plantState: r.PlantState || '',
              plantCountry: r.PlantCountry || '',
              vehicleType: r.VehicleType || '',
              manufacturer: (ad && ad.vehicle && ad.vehicle.manufacturer) || r.Manufacturer || '',
              abs: r.ABS || '',
              tractionControl: r.TractionControl || '',
              electronicStabilityControl: r.ESC || '',
              steeringLocation: r.SteeringLocation || '',
              wheelBaseType: r.WheelBaseType || '',
              wheelSizeFront: r.WheelSizeFront || '',
              wheelSizeRear: r.WheelSizeRear || '',
              entertainmentSystem: r.EntertainmentSystem || '',
              series: r.Series || '',
              series2: r.Series2 || ''
            }));
          } catch(e) {}

          rememberSearchedVin(vin);

          var collection = isDodge ? resolveCollection(model, fuelType) : null;

          function vinNoResultsUrl() {
            var terms = [year, make, model].filter(Boolean).join(' ').trim() || 'VIN lookup';
            return '/search?q=' + encodeURIComponent(terms) + '&type=product';
          }

          function yearInModelMap(handle, yr) {
            var list = modelYears[handle];
            var y = parseInt(yr, 10);
            return !!(list && y && list.indexOf(y) !== -1);
          }

          function collectionHasYear(handle, yr) {
            var y = String(yr || '').trim();
            if (!handle || !y) return Promise.resolve(false);
            return fetch('/collections/' + handle + '/products.json?limit=250')
              .then(function(res) { return res.json(); })
              .then(function(json) {
                return (json.products || []).some(function(p) {
                  if ((p.title || '').indexOf(y) !== -1) return true;
                  return String(p.tags || '').split(',').some(function(tag) {
                    return tag.trim() === y;
                  });
                });
              })
              .catch(function() {
                return yearInModelMap(handle, y);
              });
          }

          function goToVinNoResults() {
            window.location.href = vinNoResultsUrl();
          }

          if (!collection || !year) {
            goToVinNoResults();
            return;
          }

          collectionHasYear(collection, year).then(function(hasYear) {
            if (hasYear) {
              try { sessionStorage.removeItem('vin_decode_data'); } catch (e) {}
              window.location.href = '/collections/' + collection + '?year=' + encodeURIComponent(year);
              return;
            }
            goToVinNoResults();
          });
        })
        .catch(function() {
          vinBtn.textContent = 'LOOK UP VIN';
          vinBtn.disabled = false;
        });
    });

    // Allow Enter key to trigger lookup
    vinInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); vinBtn.click(); }
    });
  }

  // ── VIN decode info on search/no-results page ──
  (function() {
    var vinNoResults = document.getElementById('vin-no-results');
    if (!vinNoResults) return;

    var raw;
    try { raw = sessionStorage.getItem('vin_decode_data'); } catch(e) { return; }
    if (!raw) return;

    var d;
    try { d = JSON.parse(raw); } catch(e) { return; }
    try { sessionStorage.removeItem('vin_decode_data'); } catch(e) {}

    if (!d.year || !d.make || !d.model) return;

    // Hide the normal search results, show the VIN info page instead
    var resultsWrap = document.getElementById('search-results-wrap');
    if (resultsWrap) resultsWrap.style.display = 'none';
    var searchForm = document.querySelector('.search-page-form');
    if (searchForm) searchForm.style.display = 'none';
    var pageH1 = document.querySelector('.page-header h1');
    if (pageH1) pageH1.textContent = 'We don\'t carry this vehicle';
    vinNoResults.style.display = '';

    var titleEl = document.getElementById('vin-vehicle-title');
    titleEl.textContent = d.year + ' ' + d.make + ' ' + d.model + (d.trim ? ' ' + d.trim : '');

    function addRow(container, label, value) {
      if (!value) return;
      var dt = document.createElement('dt');
      dt.textContent = label;
      var dd = document.createElement('dd');
      dd.textContent = value;
      container.appendChild(dt);
      container.appendChild(dd);
    }

    // Vehicle section
    var secVehicle = document.getElementById('vin-section-vehicle');
    addRow(secVehicle, 'VIN', d.vin);
    addRow(secVehicle, 'Year', d.year);
    addRow(secVehicle, 'Make', d.make);
    addRow(secVehicle, 'Model', d.model);
    addRow(secVehicle, 'Trim', d.trim);
    addRow(secVehicle, 'Series', d.series);
    if (d.series2 && d.series2 !== d.series) addRow(secVehicle, 'Series 2', d.series2);
    addRow(secVehicle, 'Style', d.style);
    addRow(secVehicle, 'Body Style', d.bodyClass);
    addRow(secVehicle, 'Doors', d.doors);
    addRow(secVehicle, 'Vehicle Type', d.vehicleType);
    addRow(secVehicle, 'Manufacturer', d.manufacturer);

    // Engine section
    var secEngine = document.getElementById('vin-section-engine');
    addRow(secEngine, 'Engine', d.engineSummary);
    var engDisp = '';
    if (d.displacementL) {
      engDisp = parseFloat(d.displacementL).toFixed(1) + 'L';
      if (d.displacementCC) engDisp += ' (' + Math.round(parseFloat(d.displacementCC)) + ' cc)';
    }
    if (!d.engineSummary) addRow(secEngine, 'Displacement', engDisp);
    addRow(secEngine, 'Cylinders', d.engineCylinders ? d.engineCylinders + ' (' + (d.engineConfiguration || 'N/A') + ')' : '');
    addRow(secEngine, 'Engine Model', d.engineModel);
    var hpStr = '';
    if (d.engineHP) {
      hpStr = d.engineHP + ' HP';
      if (d.engineKW) hpStr += ' (' + d.engineKW + ' kW)';
    }
    addRow(secEngine, 'Horsepower', hpStr);
    addRow(secEngine, 'Fuel Type', d.fuelTypePrimary);
    if (d.fuelTypeSecondary) addRow(secEngine, 'Fuel Type (Secondary)', d.fuelTypeSecondary);
    addRow(secEngine, 'Fuel Injection', d.fuelInjectionType);
    addRow(secEngine, 'Valve Train', d.valveTrainDesign);

    // Drivetrain section
    var secDrive = document.getElementById('vin-section-drivetrain');
    var transStr = d.transmission || '';
    if (!transStr && d.transmissionStyle) {
      transStr = d.transmissionStyle;
      if (d.transmissionSpeeds) transStr += ' (' + d.transmissionSpeeds + '-speed)';
    }
    addRow(secDrive, 'Transmission', transStr);
    addRow(secDrive, 'Drive Type', d.driveType);

    // Other section
    var secOther = document.getElementById('vin-section-other');
    addRow(secOther, 'GVWR', d.gvwr);
    addRow(secOther, 'ABS', d.abs);
    addRow(secOther, 'Traction Control', d.tractionControl);
    addRow(secOther, 'Stability Control', d.electronicStabilityControl);
    addRow(secOther, 'Steering', d.steeringLocation);
    addRow(secOther, 'Wheel Base', d.wheelBaseType);
    if (d.wheelSizeFront) addRow(secOther, 'Wheel Size (Front)', d.wheelSizeFront + '"');
    if (d.wheelSizeRear && d.wheelSizeRear !== d.wheelSizeFront) addRow(secOther, 'Wheel Size (Rear)', d.wheelSizeRear + '"');
    addRow(secOther, 'Entertainment', d.entertainmentSystem);
    var plantStr = '';
    if (d.plantCity) {
      plantStr = d.plantCity;
      if (d.plantState) plantStr += ', ' + d.plantState;
      if (d.plantCountry) plantStr += ', ' + d.plantCountry;
    }
    addRow(secOther, 'Assembly Plant', plantStr);
  })();

  // ── Cart page: quantity +/-, remove ──
  function cartUpdate(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function() { window.location.reload(); });
  }

  document.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = parseInt(this.dataset.line);
      var input = this.parentElement.querySelector('.cart-qty-input');
      var val = parseInt(input.value);
      if (this.dataset.action === 'increase') {
        cartUpdate(line, val + 1);
      } else if (this.dataset.action === 'decrease') {
        cartUpdate(line, Math.max(0, val - 1));
      }
    });
  });

  document.querySelectorAll('.cart-qty-input').forEach(function(input) {
    input.addEventListener('change', function() {
      var line = parseInt(this.dataset.line);
      cartUpdate(line, Math.max(0, parseInt(this.value) || 0));
    });
  });

  document.querySelectorAll('.cart-remove-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = parseInt(this.dataset.line);
      cartUpdate(line, 0);
    });
  });

  /* ═══ COLLECTION PAGE FILTERS ═══ */
  var filterCheckboxes = document.querySelectorAll('.collection-sidebar input[type="checkbox"]');
  var productCards = document.querySelectorAll('.products-grid .product-card');
  var noFilterResults = document.getElementById('no-filter-results');
  var clearBtn = document.querySelector('.filter-clear-btn');

  var yearSelect = document.getElementById('mobile-year-select');

  function isMobileCollection() {
    return window.matchMedia('(max-width: 992px)').matches;
  }

  function yearOptionExists(year) {
    if (!year) return false;
    if (yearSelect && Array.prototype.some.call(yearSelect.options, function(opt) {
      return opt.value === year;
    })) return true;
    return Array.prototype.some.call(productCards, function(card) {
      return (card.getAttribute('data-year') || '') === year;
    });
  }

  function setYearInUrl(year) {
    if (!window.history || !history.replaceState) return;
    var url = new URL(window.location.href);
    if (year) url.searchParams.set('year', year);
    else url.searchParams.delete('year');
    history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  function applyYearToControls(year) {
    var validYear = yearOptionExists(year) ? year : '';
    if (yearSelect) yearSelect.value = validYear;
    filterCheckboxes.forEach(function(cb) {
      if (cb.name === 'filter-year') cb.checked = !!(validYear && cb.value === validYear);
    });
    return validYear;
  }

  function applyFilters() {
    var activeFilters = {};
    filterCheckboxes.forEach(function(cb) {
      if (cb.checked) {
        var name = cb.name;
        if (!activeFilters[name]) activeFilters[name] = [];
        activeFilters[name].push(cb.value);
      }
    });

    if (isMobileCollection() && yearSelect) {
      if (yearSelect.value) activeFilters['filter-year'] = [yearSelect.value];
      else delete activeFilters['filter-year'];
    }

    var filterKeys = Object.keys(activeFilters);
    var visible = 0;

    productCards.forEach(function(card) {
      var show = true;

      if (activeFilters['filter-year']) {
        var cardYear = card.getAttribute('data-year') || '';
        if (activeFilters['filter-year'].indexOf(cardYear) === -1) show = false;
      }

      if (show && activeFilters['filter-engine']) {
        var cardEngine = card.getAttribute('data-engine');
        if (activeFilters['filter-engine'].indexOf(cardEngine) === -1) show = false;
      }

      if (show && activeFilters['filter-type']) {
        var cardType = card.getAttribute('data-module-type');
        if (activeFilters['filter-type'].indexOf(cardType) === -1) show = false;
      }

      if (show && activeFilters['filter-product']) {
        var cardProduct = card.getAttribute('data-product-type');
        if (activeFilters['filter-product'].indexOf(cardProduct) === -1) show = false;
      }

      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (noFilterResults) noFilterResults.style.display = (visible === 0 && productCards.length > 0) ? '' : 'none';
    if (clearBtn) clearBtn.style.display = filterKeys.length > 0 ? '' : 'none';
  }

  filterCheckboxes.forEach(function(cb) {
    cb.addEventListener('change', applyFilters);
  });

  if (yearSelect) {
    yearSelect.addEventListener('change', function() {
      var year = applyYearToControls(yearSelect.value);
      setYearInUrl(year);
      applyFilters();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      filterCheckboxes.forEach(function(cb) { cb.checked = false; });
      if (yearSelect) yearSelect.value = '';
      setYearInUrl('');
      applyFilters();
    });
  }

  /* ═══ SORT ═══ */
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect && productCards.length > 0) {
    sortSelect.addEventListener('change', function() {
      var grid = document.querySelector('.products-grid');
      var cards = Array.prototype.slice.call(productCards);
      var val = this.value;

      cards.sort(function(a, b) {
        if (val === 'title-ascending') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        if (val === 'title-descending') return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '');
        if (val === 'price-ascending') return parseFloat(a.getAttribute('data-price') || 0) - parseFloat(b.getAttribute('data-price') || 0);
        if (val === 'price-descending') return parseFloat(b.getAttribute('data-price') || 0) - parseFloat(a.getAttribute('data-price') || 0);
        return 0;
      });

      cards.forEach(function(card) { grid.appendChild(card); });
    });
  }

  /* ═══ MOBILE FILTER TOGGLE ═══ */
  var filterToggle = document.querySelector('.filter-toggle-btn');
  var sidebar = document.querySelector('.collection-sidebar');

  if (filterToggle && sidebar) {
    var overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    filterToggle.addEventListener('click', function() {
      sidebar.classList.toggle('sidebar-open');
      overlay.classList.toggle('active');
    });

    overlay.addEventListener('click', function() {
      sidebar.classList.remove('sidebar-open');
      overlay.classList.remove('active');
    });
  }

  // Auto-apply year filter from URL param (VIN lookup / finder redirect).
  // A VIN for a model we sell in other years must not dump the whole category.
  var urlYear = new URLSearchParams(window.location.search).get('year');
  if (urlYear) {
    if (yearOptionExists(urlYear)) {
      try { sessionStorage.removeItem('vin_decode_data'); } catch (e) {}
      applyYearToControls(urlYear);
      applyFilters();
    } else {
      var vinPending = false;
      try { vinPending = !!sessionStorage.getItem('vin_decode_data'); } catch (e) {}
      if (vinPending) {
        window.location.replace('/search?q=' + encodeURIComponent(urlYear + ' VIN lookup') + '&type=product');
      }
    }
  }

  /* ═══ DEDUPLICATE SYMPTOMS IN PRODUCT DESCRIPTION ═══ */
  var symptomList = document.querySelector('.product-description ul');
  if (symptomList) {
    var seenMds = false;
    var seenTexts = {};
    var listItems = Array.from(symptomList.querySelectorAll('li'));
    listItems.forEach(function(li) {
      var raw = li.textContent.trim().toLowerCase();
      if (seenTexts[raw]) {
        li.remove();
        return;
      }
      seenTexts[raw] = true;
      if (raw.indexOf('mds') !== -1) {
        if (seenMds) {
          li.remove();
        } else {
          seenMds = true;
        }
      }
    });
  }

  /* ═══ INTERACTIVE PART NUMBERS LOOKUP & CHIP GRID ═══ */
  var pnContainers = document.querySelectorAll('.part-numbers');
  pnContainers.forEach(function(container) {
    var paragraphs = Array.from(container.querySelectorAll('p'));
    var rawPnItems = [];
    var rawHwItems = [];

    paragraphs.forEach(function(p) {
      var text = p.textContent.trim();
      if (/Compatible Part Numbers|Part Numbers\s*\(P\/N\)/i.test(text)) {
        var links = p.querySelectorAll('a');
        if (links.length > 0) {
          links.forEach(function(a) {
            var val = a.textContent.trim().replace(/^[,;\s]+|[,;\s]+$/g, '');
            if (val) rawPnItems.push({ text: val, href: a.href });
          });
        } else {
          var parts = text.split(/Compatible Part Numbers\s*\(P\/N\)\s*:\s*/i);
          var pnString = parts.length > 1 ? parts[1] : text;
          var tokens = pnString.split(/[,;\s&bull;]+/);
          tokens.forEach(function(t) {
            var clean = t.trim().replace(/^[,;\s]+|[,;\s]+$/g, '');
            if (clean && clean.length >= 4 && !/^(compatible|part|numbers|p\/n|hardware|code)$/i.test(clean)) {
              rawPnItems.push({ text: clean, href: null });
            }
          });
        }
      } else if (/Hardware code\s*:/i.test(text)) {
        var hwParts = text.split(/Hardware code\s*:\s*/i);
        var hwString = hwParts.length > 1 ? hwParts[1] : text;
        var hwTokens = hwString.split(/[,;\s&bull;]+/);
        hwTokens.forEach(function(t) {
          var clean = t.trim().replace(/^[,;\s]+|[,;\s]+$/g, '');
          if (clean && clean.length >= 4 && !/^(hardware|code)$/i.test(clean)) {
            rawHwItems.push({ text: clean });
          }
        });
      }
    });

    if (rawPnItems.length === 0) return;

    var widget = document.createElement('div');
    widget.className = 'pn-widget';

    var header = document.createElement('div');
    header.className = 'pn-widget-header';
    header.innerHTML = 
      '<div class="pn-widget-title-row">' +
        '<h3 class="pn-widget-title">Interchangeable Part Numbers</h3>' +
        '<span class="pn-widget-count">' + rawPnItems.length + ' Part Numbers</span>' +
      '</div>' +
      '<p class="pn-widget-subtitle">Pre-programmed to your VIN before shipping. Directly replaces and interchanges with any of these OEM part numbers.</p>' +
      '<div class="pn-search-box">' +
        '<div class="pn-search-input-wrap">' +
          '<svg class="pn-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
          '<input type="text" class="pn-search-input" placeholder="Type your part number to verify fitment (e.g. ' + (rawPnItems[0] ? rawPnItems[0].text : '04606839') + ')..." aria-label="Verify part number">' +
          '<button type="button" class="pn-search-clear" style="display:none;" aria-label="Clear search">×</button>' +
        '</div>' +
        '<div class="pn-search-feedback" style="display:none;" aria-live="polite"></div>' +
      '</div>';

    var gridSection = document.createElement('div');
    gridSection.className = 'pn-grid-section';

    var chipsList = document.createElement('div');
    chipsList.className = 'pn-chips-list';

    var chipElements = [];

    rawPnItems.forEach(function(item) {
      var el;
      if (item.href) {
        el = document.createElement('a');
        el.href = item.href;
      } else {
        el = document.createElement('span');
      }
      var currentPath = window.location.pathname.toLowerCase();
      var isCurrent = item.text && (currentPath === '/products/' + item.text.toLowerCase() || (item.href && currentPath === new URL(item.href, window.location.origin).pathname.toLowerCase()));
      el.className = 'pn-chip' + (isCurrent ? ' is-current' : '');
      el.textContent = item.text;
      el.setAttribute('data-pn', item.text.toUpperCase());
      chipsList.appendChild(el);
      chipElements.push(el);
    });

    gridSection.appendChild(chipsList);

    var hwSection = null;
    if (rawHwItems.length > 0) {
      hwSection = document.createElement('p');
      hwSection.className = 'pn-hw-block';
      var hwLabel = document.createElement('strong');
      hwLabel.textContent = 'Hardware Code:';
      hwSection.appendChild(hwLabel);
      hwSection.appendChild(document.createTextNode(' ' + rawHwItems.map(function(hw) { return hw.text; }).join(', ')));
    }

    widget.appendChild(header);
    widget.appendChild(gridSection);
    if (hwSection) widget.appendChild(hwSection);

    var searchInput = header.querySelector('.pn-search-input');
    var clearBtn = header.querySelector('.pn-search-clear');
    var feedback = header.querySelector('.pn-search-feedback');

    function normalizePn(val) {
      return String(val || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    searchInput.addEventListener('input', function() {
      var query = normalizePn(this.value);
      clearBtn.style.display = query ? 'flex' : 'none';

      if (!query) {
        feedback.style.display = 'none';
        feedback.innerHTML = '';
        chipElements.forEach(function(c) {
          c.classList.remove('is-match', 'is-dimmed');
        });
        return;
      }

      var matches = [];
      chipElements.forEach(function(c) {
        var pn = normalizePn(c.getAttribute('data-pn'));
        var isMatch = pn.indexOf(query) !== -1;
        if (isMatch) {
          matches.push(c.getAttribute('data-pn'));
          c.classList.add('is-match');
          c.classList.remove('is-dimmed');
        } else {
          c.classList.remove('is-match');
          c.classList.add('is-dimmed');
        }
      });

      feedback.style.display = 'block';
      if (matches.length > 0) {
        feedback.className = 'pn-search-feedback pn-feedback is-success';
        feedback.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
          '<div><strong>Verified Match!</strong> Found ' + matches.length + ' matching part number' + (matches.length > 1 ? 's' : '') + ' (' + matches.slice(0, 3).join(', ') + (matches.length > 3 ? '...' : '') + '). This module is guaranteed compatible with your vehicle.</div>';
      } else if (query.length >= 4) {
        feedback.className = 'pn-search-feedback pn-feedback is-nomatch';
        feedback.innerHTML = 
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>' +
          '<div><strong>No exact match for "' + this.value.trim() + '".</strong> Part numbers often differ by letter suffixes across model years. Call <strong>1-888-735-1564</strong> with your VIN or sticker photo to confirm fitment.</div>';
      } else {
        feedback.style.display = 'none';
      }
    });

    clearBtn.addEventListener('click', function() {
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input'));
      searchInput.focus();
    });

    container.innerHTML = '';
    container.appendChild(widget);
  });

  /* ═══ MOBILE STICKY CART — stay above iOS Safari chrome & show on scroll ═══ */
  var stickyCart = document.querySelector('.mobile-sticky-cart');
  if (stickyCart) {
    var vvRoot = document.documentElement;
    var vvTicking = false;

    function setStickyCartOffset() {
      var vv = window.visualViewport;
      var overlap = 0;
      if (vv) {
        overlap = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      }
      vvRoot.style.setProperty('--vv-bottom', overlap + 'px');
      vvTicking = false;
    }

    function onVisualViewportChange() {
      if (vvTicking) return;
      vvTicking = true;
      window.requestAnimationFrame(setStickyCartOffset);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onVisualViewportChange);
      window.visualViewport.addEventListener('scroll', onVisualViewportChange);
    }
    window.addEventListener('resize', onVisualViewportChange);
    setStickyCartOffset();

    // Only reveal sticky button when scrolled past main above-the-fold CTA
    var mainAddCartBtn = document.querySelector('.product-info .btn-add-cart') || document.querySelector('.add-to-cart-form');
    if (mainAddCartBtn) {
      function checkStickyCartVisibility() {
        var rect = mainAddCartBtn.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyCart.classList.add('is-visible');
        } else {
          stickyCart.classList.remove('is-visible');
        }
      }

      window.addEventListener('scroll', checkStickyCartVisibility, { passive: true });
      window.addEventListener('resize', checkStickyCartVisibility, { passive: true });
      checkStickyCartVisibility();
    } else {
      stickyCart.classList.add('is-visible');
    }
  }
});
